import { render, staticRenderFns } from "./onesti-footer.vue?vue&type=template&id=1895e330&scoped=true&"
import script from "./onesti-footer.vue?vue&type=script&lang=js&"
export * from "./onesti-footer.vue?vue&type=script&lang=js&"
import style0 from "./onesti-footer.vue?vue&type=style&index=0&id=1895e330&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895e330",
  null
  
)

export default component.exports